module.exports = __webpack_public_path__ + "img/secondary_7x4_z16.2a97a7c0.svg";